import API from '../Api'
import http from '../http'

/**
 * 获取申诉列表
 * @returns {*}
 */
function getApply () {
  return http.get(API.getApply, {
    params: {}
  })
}

/**
 * 处理申诉
 * @param id
 * @returns {*|AxiosPromise<any>|void}
 */
function untieApply (id) {
  return http.post(API.untieApply, {
    id: id
  })
}

/**
 * 获取意见反馈
 * @returns {*}
 */
function getFeedback (id) {
  return http.get(API.feedback, {
    params: {
      id: id
    }
  })
}

/**
 * 获取学生的班级以及老师信息
 * @param userCode
 * @returns {*}
 */
function getStudentClassInfo (userCode) {
  return http.get(API.getTeacherInfo, {
    params: {
      user_code: userCode
    }
  })
}

function delClassStudent (userCode, session, appId, classId, studentId) {
  return http.post(API.delStudent, {
    user_code: userCode,
    session: session,
    app_id: appId,
    class_id: classId,
    student_id: studentId
  })
}

function getAppleInfos () {
  return http.get(API.appleInfo, {
    params: {}
  })
}

function getAppleDetail (id) {
  return http.get(API.appleDetail, {
    params: {
      id: id
    }
  })
}

function dealApple (id, appOnOff) {
  return http.post(API.dealApple, {
    id: id,
    app_on_off: appOnOff
  })
}

export default {
  getApply,
  untieApply,
  getFeedback,
  getStudentClassInfo,
  delClassStudent,
  getAppleInfos,
  getAppleDetail,
  dealApple
}



// WEBPACK FOOTER //
// ./src/service/main/index.js